import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { UIState, Theme, PageName, Modals } from '@/types'

const initialState: UIState = {
  currentPage: 'home',
  loading: false,
  modals: {
    investmentSearch: false,
    realEstateForm: false,
    debtForm: false,
    budgetForm: false,
    sellingOrders: false,
  },
  notifications: [],
  sidebarOpen: false,
  theme: 'dark',
  charts: {
    portfolio: null,
    realEstate: null,
    retirement: null,
  },
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<PageName>) => {
      state.currentPage = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    toggleModal: (state, action: PayloadAction<{ modal: keyof Modals; isOpen: boolean }>) => {
      const { modal, isOpen } = action.payload
      if (modal in state.modals) {
        state.modals[modal] = isOpen
      }
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload
    },
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload
    },
    setChart: (state, action: PayloadAction<{ chartType: keyof typeof initialState.charts; chartInstance: unknown }>) => {
      const { chartType, chartInstance } = action.payload
      if (chartType in state.charts) {
        state.charts[chartType] = chartInstance
      }
    },
    clearChart: (state, action: PayloadAction<keyof typeof initialState.charts>) => {
      const chartType = action.payload
      if (chartType in state.charts) {
        state.charts[chartType] = null
      }
    },
  },
})

export const {
  setCurrentPage,
  setLoading,
  toggleModal,
  toggleSidebar,
  setSidebarOpen,
  setTheme,
  setChart,
  clearChart,
} = uiSlice.actions

export default uiSlice.reducer
